var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashBoardAskByzIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34444 0H14.6567C18.0889 0 20 1.78 20 4.83V15.16C20 18.26 18.0889 20 14.6567 20H5.34444C1.96667 20 0 18.26 0 15.16V4.83C0 1.78 1.96667 0 5.34444 0ZM12.064 14.44L13.156 15.672L14.052 14.86L12.988 13.656C13.814 12.732 14.304 11.444 14.304 9.932C14.304 6.852 12.302 4.696 9.432 4.696C6.576 4.696 4.574 6.866 4.574 9.932C4.574 13.012 6.562 15.168 9.418 15.168C10.412 15.168 11.308 14.902 12.064 14.44ZM9.432 6.026C11.49 6.026 12.862 7.58 12.862 9.932C12.862 11.01 12.568 11.934 12.05 12.606L10.706 11.094L9.81 11.906L11.14 13.404C10.65 13.698 10.076 13.852 9.432 13.852C7.374 13.852 6.016 12.284 6.016 9.932C6.016 7.58 7.374 6.026 9.432 6.026Z",
    fill: "#BB4A9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashBoardAskByzIcon);
export default __webpack_public_path__ + "static/media/DashBoardAskByzIcon.25e10dfa72fa51056e08042976109227.svg";
export { ForwardRef as ReactComponent };